<template>
  <div class="forgot-password">
    <div class="forgot-password__container">
      <b-card>
        <div class="logo-wrapper">
          <img :src="logo" alt="" />
        </div>
        <h5 class="mb-5 text-center text-white font-bold">Reset Password</h5>
        <b-form class="text-center" v-if="requestDone === false">
          <b-form-group
            class="text-left input-wrapper"
            :state="state"
            invalid-feedback="Cannot be empty."
          >
            <label for="email">Email</label>
            <b-form-input
              id="email"
              v-model="formData.email"
              :state="state"
              placeholder="Enter your email"
              trim
              type="email"
              required
              autocomplete="off"
            />
          </b-form-group>
          <div class="text-center">
            <b-btn
              class="btn-yellow"
              @click.prevent="submit"
              :disabled="loading"
            >
              {{ buttonCaption }}
            </b-btn>
          </div>
        </b-form>
        <div class="success-message" v-else>
          If we found an account associated with that email address, we've sent
          password reset instructions to the email address on the
          account.
        </div>

        <div class="mt-4">
          <div class="text-center text-white">
            Don't have a account?
            <router-link to="/register" class="register-link">
              Sign up now!
            </router-link>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import appLogo from "@/assets/img/logo.svg";
import { AuthService } from "../data/services/auth.service";
export default {
  data() {
    return {
      logo: appLogo,
      formData: {
        email: "",
      },
      name: "",
      state: null,
      loading: false,
      requestDone: false,
    };
  },
  computed: {
    buttonCaption() {
      return this.loading === false ? "Send Reset Instruction" : "Loading";
    },
  },
  methods: {
    checkState() {
      this.state = this.formData.email !== "" ? null : false;
    },
    async submit() {
      this.checkState();
      if (this.state === false) {
        return;
      }

      if (this.loading === true) {
        return;
      }
      this.loading = true;

      const authService = new AuthService();
      await authService.forgotPassword(this.formData);
      this.loading = false;
      this.requestDone = true
    },
  },
};
</script>
<style lang="scss" scoped>
.forgot-password {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: #024089;
  height: 100vh;
  width: 100vw;

  &__container {
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  .card {
    background-color: transparent;
    border-color: transparent;
  }

  .logo-wrapper {
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 65px;
      width: 65px;
    }
  }

  .input-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    label {
      font-size: 13px;
      font-weight: lighter;
      color: #fff;
      margin-bottom: 0px;
      margin-left: 10px;
    }
    input {
      padding: 8px 10px;
      font-weight: lighter;
      color: #ffffff;
      margin-bottom: 10px;
      background-color: transparent !important;
      border-color: transparent !important;
      border-bottom: 1px solid #ffffff !important;
      outline: none;

      &::placeholder {
        font-weight: lighter;
        font-size: 11px;
        color: lightblue;
      }
      &:focus {
        box-shadow: none !important;
      }
    }
  }

  .btn-yellow {
    background: #f1bc04;
    border-color: #f1bc04;
    border-radius: 45px;
    color: #000000;
    min-width: 145px;
    height: 40px;
    line-height: 16px;
    font-size: 13px;
    padding: 11px 30px;
  }
  .register-link {
    color: #f1bc04;
  }
  .success-message {
    width: 300px;
    color: #f8f8f8;
  }
}
</style>
